import { Grid, Paper, Typography } from '@mui/material';
import DemandOverview from './DemandOverview.jsx';
import SupplyOverviewContainer from './SupplyOverview/index.jsx';
import './styles/secureAdServer.css';

function SecureAdServer() {
  return (
    <Paper
      elevation={1}
      sx={{
        p: { xs: 1, md: 2 },
        borderRadius: 4,
        bgcolor: '#F7F7F7',
      }}>
      <Typography
        variant="h5"
        sx={{ mb: 2, fontWeight: 500 }}>
        Secure Ad Server
      </Typography>

      <Grid
        container
        spacing={2}>
        <Grid size={12}>
          <DemandOverview />
        </Grid>
        <Grid size={12}>
          <SupplyOverviewContainer />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default SecureAdServer;
